import React, { useState } from "react";
import { nanoid } from "nanoid";

export default function GolfCart(props) {
  const carColorOptions = window.$golf_cart_colors.map((item) => {
    return <option key={nanoid()}>{item}</option>;
  });
  return (
    <div className="vehicle_info">
      <div className="VehicleMake">
        <label htmlFor="vehicle_color">Golf Cart Color</label>
        <select
          id="vehicle_color"
          name="vehicle_color"
          value={props.color}
          onChange={(event) => props.handleColor(event, props.index)}
        >
          <option key={nanoid()} disabled={true} value="">
            Select Color
          </option>
          {carColorOptions.map((item) => {
            return <option key={nanoid()}>{item}</option>;
          })}
        </select>
      </div>
      <div className="vehicle_container">
        <div className="remove_vehicle">
          <button
            className="remove_text"
            onClick={(event) => props.removeVehicle(event, props.index)}
          >
            X
          </button>
        </div>
      </div>
    </div>
  );
}
